export const TABLE_CELL_WIDTH = {
  ACTIONS: 40,
  NUMERATION: 48,
  SM: 80,
  MD: 128,
  LG: 200,
  XL: 240
}
